// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__EwVYi","inner":"Footer_inner__fhIqU","left":"Footer_left__+35ST","socials":"Footer_socials__bqeqA","link":"Footer_link__MsGIJ"};